import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import './HomePage.css';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    const AOS = require('aos');
    import('aos/dist/aos.css');
    AOS.init({
      duration: 1000,
      once: false
    });
    
    // Add smooth scroll behavior for all links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        });
      });
    });
  }, []);

  const handleOrderNow = () => {
    navigate('/order');
  };

  return (
    <div className="bakery-container">
      {/* Hero Section with Parallax */}
      <header className="hero-section parallax-section text-center">
        <div className="parallax-bg hero-bg"></div>
        <div className="container content-overlay">
          <a href="https://www.banhkemdongtien.com/logout" className="btn btn-primary btn-lg mt-3 animate__animated animate__pulse animate__infinite">
            Đăng nhập ngay
          </a>
        </div>
      </header>

      {/* About Section */}
      <section className="about-section py-5">
        <div className="container" data-aos="fade-up">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="section-title">Our Bakery Story</h2>
              <p>
                Founded in 2010, our bakery has been serving the community with delicious 
                treats made from traditional recipes passed down through generations.
              </p>
              <p>
                We take pride in using only the freshest ingredients and baking everything 
                from scratch daily.
              </p>
            </div>
            <div className="col-md-6">
              <div className="bakery-image-container">
                <img 
                  src="https://images.unsplash.com/photo-1517433670267-08bbd4be890f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                  alt="Bakery interior" 
                  className="img-fluid rounded shadow" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Parallax Divider */}
      <section className="parallax-section divider-section">
        <div className="parallax-bg bread-bg"></div>
        <div className="content-overlay">
          <h2 className="text-center">Freshly Baked Every Morning</h2>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="products-section py-5">
        <div className="container" data-aos="fade-up">
          <h2 className="section-title text-center mb-5">Our Delicious Products</h2>
          <div className="row">
            <div className="col-md-4 mb-4" data-aos="flip-left" data-aos-delay="100">
              <div className="card product-card h-100">
                <div className="product-image-container">
                  <img 
                    src="https://images.unsplash.com/photo-1578985545062-69928b1d9587?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    className="card-img-top" 
                    alt="Chocolate Cake" 
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">Chocolate Cake</h5>
                  <p className="card-text">Rich, moist chocolate cake with our special ganache frosting.</p>
                  <p className="price">$10</p>
                  <button className="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4" data-aos="flip-left" data-aos-delay="200">
              <div className="card product-card h-100">
                <div className="product-image-container">
                  <img 
                    src="https://images.unsplash.com/photo-1587668178277-295251f900ce?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    className="card-img-top" 
                    alt="Blueberry Muffin" 
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">Blueberry Muffin</h5>
                  <p className="card-text">Fluffy muffins packed with fresh blueberries and topped with streusel.</p>
                  <p className="price">$5</p>
                  <button className="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4" data-aos="flip-left" data-aos-delay="300">
              <div className="card product-card h-100">
                <div className="product-image-container">
                  <img 
                    src="https://images.unsplash.com/photo-1568471173242-461f0a730452?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                    className="card-img-top" 
                    alt="French Baguette" 
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">French Baguette</h5>
                  <p className="card-text">Crispy on the outside, soft on the inside authentic French bread.</p>
                  <p className="price">$3</p>
                  <button className="btn btn-outline-primary">Add to Cart</button>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <button className="btn btn-primary btn-lg">View All Products</button>
          </div>
        </div>
      </section>

      {/* Parallax Divider */}
      <section className="parallax-section divider-section">
        <div className="parallax-bg pastry-bg"></div>
        <div className="content-overlay">
          <h2 className="text-center">Handcrafted with Love</h2>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section text-center py-5">
        <div className="container" data-aos="zoom-in">
          <h2>Ready to Order?</h2>
          <p className="lead">Place your order now and enjoy our fresh baked goods!</p>
          <button 
            className="btn btn-danger btn-lg animate__animated animate__heartBeat animate__infinite"
            onClick={handleOrderNow}
          >
            Order Now
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer bg-dark text-white py-4">
        <div className="container text-center">
          <p>© 2023 Sweet Delights Bakery. All rights reserved.</p>
          <div className="social-icons">
            <a href="#" className="text-white mx-2"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="text-white mx-2"><i className="fab fa-instagram"></i></a>
            <a href="#" className="text-white mx-2"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
